<template>
  <form class="default-form row">
    <!-- <div class="form-group col-lg-12">
      <google-map-customer-address
        :incoming_lat_lng="
          localAddressToEdit ? deliveryArea.location_coordinates : ''
        "
        @addressFound="addressFound"
      ></google-map-customer-address>
      <span
        class="validation-error  d-block pt-1"
        v-if="errors.location_coordinates"
      >
        {{ errors.location_coordinates }}
      </span>
    </div> -->
    <div class="form-group col-lg-12">
      <label>{{ _T('Delivery Area') }}</label>
      <select-delivery-area-form ref="selectDeliveryAreaForm" />
    </div>
    <div class="form-group col-lg-6">
      <label>{{ _T('Street') }}</label>
      <span>*</span>
      <input
        type="text"
        class="form-control"
        :class="{ 'border-danger': errors.street }"
        v-model="deliveryArea.street"
      />
      <span class="validation-error d-block pt-1" v-if="errors.street">
        {{ errors.street }}
      </span>
    </div>
    <div class="form-group col-lg-6">
      <label>{{ _T('Building/Villa') }}</label>
      <span>*</span>
      <input
        type="text"
        class="form-control"
        :class="{ 'border-danger': errors.building }"
        v-model="deliveryArea.building"
      />
      <span class="validation-error  d-block pt-1" v-if="errors.building">
        {{ errors.building }}
      </span>
    </div>
    <div class="form-group col-lg-6">
      <label>{{ _T('Flat #') }}</label>
      <span>*</span>
      <input
        type="text"
        class="form-control"
        v-model="deliveryArea.flat_number"
        :class="{ 'border-danger': errors.flat_number }"
      />
      <span class="validation-error  d-block pt-1" v-if="errors.flat_number">
        {{ errors.flat_number }}
      </span>
    </div>
    <div class="form-group col-lg-6">
      <label>{{ _T('Nearest Landmark') }}</label>
      <input
        type="text"
        class="form-control"
        v-model="deliveryArea.nearest_landmark"
      />
    </div>
    <span class="validation-error  d-block pt-1" v-if="errors.api_errors"
      >{{ errors.api_errors }}
    </span>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import { handleApiErrors } from '@/utils/main_utils.js'
import { eventBus } from '@/eventBus'
import { isObjectEmpty } from '../../../utils/main_utils'
import selectDeliveryAreaForm from '@/components/SelectDeliveryAreaForm'
export default {
  name: 'CreateAddressForm',
  props: ['address', 'coordinates'],
  components: {
    selectDeliveryAreaForm,
    GoogleMapCustomerAddress: () =>
      import('@/components/Blocks/GoogleMapCustomerAddress'),
  },
  data() {
    return {
      delivery_area_id: '',
      errors: {},
      process: 'customer-address',
      isEditing: false,
    }
  },
  computed: {
    deliveryArea: {
      get() {
        return this.$store.getters.userStreet
      },
      set(val) {
        this.$store.commit('SET_USER_STREET', val)
      }
    },
    ...mapGetters([
      '_T',
      'currentStoreId',
      'customer_addresses',
      'customer_address',
      'getAddressToEdit',
      'processInProgress',
      'brandStoreRoute',
      'guest_checkout',
      'find_delivery_areas_by_value',
      'selectedDaId',
    ]),
    google: gmapApi,
    localAddressToEdit() {
      return this.getAddressToEdit
    },
  },

  watch: {
    localAddressToEdit() {
      if (this.getAddressToEdit) {
        for (var addr of this.customer_addresses) {
          if (addr._id.$oid == this.getAddressToEdit.$oid) {
            this.delivery_area_id = addr.delivery_area_id
            this.deliveryArea.street = addr.street
            this.deliveryArea.building = addr.building
            this.deliveryArea.lat_lng_available = addr.lat_lng_available
            this.deliveryArea.location_coordinates = addr.location_coordinates
            this.deliveryArea.flat_number = addr.flat_number
            this.deliveryArea.nearest_landmark = addr.nearest_landmark
            return
          }
        }
      }
      this.delivery_area_id = ''
      this.deliveryArea.street = ''
      this.deliveryArea.building = ''
      this.deliveryArea.lat_lng_available = true
      this.deliveryArea.location_coordinates = {
        lat: 0,
        lng: 0,
      }
      this.deliveryArea.flat_number = ''
      this.deliveryArea.nearest_landmark = ''
    },
  },
  methods: {
    // addressFound(address) {
    //   this.deliveryArea.street = ''
    //   this.deliveryArea.building = ''
    //   this.delivery_area_id = undefined
    //   var valid_types = {
    //     locality: 1,
    //     neighborhood: 1,
    //     sublocality_level_1: 1,
    //     sublocality_level_2: 1,
    //     sublocality_level_3: 1,
    //     sublocality_level_4: 1,
    //     sublocality_level_5: 1,
    //     administrative_area_level_1: 1,
    //     administrative_area_level_2: 1,
    //     administrative_area_level_3: 1,
    //     administrative_area_level_4: 1,
    //     administrative_area_level_5: 1,
    //   }
    //   for (var el of address.address_components) {
    //     if (el.types.includes('route')) {
    //       this.deliveryArea.street = el.long_name.trim()
    //     }
    //   }
    //   var city = undefined
    //   var country = undefined
    //   for (let a of address.address_components) {
    //     if (a.types.includes('locality')) {
    //       city = a.long_name
    //     }
    //     if (a.types.includes('country')) {
    //       country = a.short_name
    //     }
    //   }
    //   address.city = city ? city.trim() : ''
    //   address.country_code = country.trim()

    //   for (var a of address.address_components) {
    //     var all_types = a.types
    //     for (let tp of all_types) {
    //       if (valid_types[tp]) {
    //         var da = this.find_delivery_areas_by_value(
    //           a.long_name.trim() + '|' + city + '|' + country
    //         )
    //         if (da) {
    //           this.delivery_area_id =
    //             a.long_name.trim() + '|' + city + '|' + country
    //           break
    //         }
    //       }
    //     }
    //     if (this.delivery_area_id) {
    //       break
    //     }
    //   }
    //   this.deliveryArea.lat_lng_available = true
    //   this.deliveryArea.location_coordinates = {
    //     lat: address.geometry.location.lat(),
    //     lng: address.geometry.location.lng(),
    //   }
    //   if (this.guest_checkout && this.delivery_area_id) {
    //     this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', {
    //       ...this.deliveryArea,
    //       delivery_area_id: this.delivery_area_id,
    //     })
    //   }
    // },
    validateForm(option = 'add') {
      this.errors = {}

      if (!this.$store.getters.locationCity) {
        this.errors.api_errors = 'Please select delivery city'
      } else if (!this.$store.state.da_store.selectedDa) {
        this.errors.api_errors = 'Please select a delivery area'
      } else if (!this.selectedDaId) {
        this.errors.api_errors = 'No delivery areas found'
      }
      
      if (!this.deliveryArea.building) {
        this.errors.building = this._T('Please provide building/villa')
      }
      if (!this.deliveryArea.flat_number) {
        this.errors.flat_number = this._T('Please provide flat no.')
      }
      if (!this.deliveryArea.street) {
        this.errors.street = this._T('Please provide street')
      }
      // if (
      //   this.deliveryArea.location_coordinates.lat == 0 ||
      //   this.deliveryArea.location_coordinates.lng == 0
      // ) {
      //   this.errors.location_coordinates = this._T(
      //     'Please put the marker on the map'
      //   )
      // }
      if (this.deliveryArea.street && this.deliveryArea.street.length < 2) {
        this.errors.street = this._T('Street should be at least 2 characters')
      }

      if (isObjectEmpty(this.errors)) {
        if (option == 'guest') {
          this.$refs.selectDeliveryAreaForm.setMutations(false)
          this.$store.commit('SET_CUSTOMER_SELECTED_ADDRESS', {
            ...this.deliveryArea,
            delivery_area_id: this.selectedDaId,
          })
        } else {
          this.addAddress()
        }
      }

      return this.errors
    },
    addAddress() {
      if (!this.processInProgress(this.process)) {
        this.$store.dispatch('startProcess', {
          process: this.process,
          progress: true,
        })
        const payLoad = {
          ...this.deliveryArea,
          delivery_area_id: this.selectedDaId,
        }
        var action = 'createNewAddress'
        if (this.isEditing) {
          action = 'editCustomerAddress'
        }
        this.$store
          .dispatch(action, payLoad)
          .then(resp => {
            let responseData = resp.data
            if (responseData.status === 'form_errors') {
              this.errors.api_errors = handleApiErrors(responseData.form_errors)
            } else {
              this.reloadCustomer(responseData.id)
                .then(() => {
                  this.errors = {}
                  this.resetForm()
                  let successMsg = this._T('Record added succesfully')
                  if (this.isEditing) successMsg = this._T('Record updated succesfully')
                  this.$store.dispatch('showNotification', {
                    text: this._T(successMsg),
                    status: 'success',
                  })
                  const brandId = this.$route.params.brand_id
                  const storeId = this.$route.params.store_id
                  if (
                    brandId &&
                    storeId &&
                    this.$route.name != this.brandStoreRoute('cart')
                  ) {
                    this.$router.push({
                      name: this.brandStoreRoute('cart'),
                      params: { brand_id: brandId, store_id: storeId },
                    })
                  }
                  this.$emit('close-modal')

                  eventBus.$emit('customerAddressAdded', responseData.id)
                })
                .finally(() => {
                  this.$store.dispatch('stopProcess', this.process)
                })
            }
          })
          .catch(err => {
            this.errors.api_errors = err
            this.$store.dispatch('stopProcess', this.process)
          })
      }
    },
    reloadCustomer() {
      return new Promise(resolve => {
        this.$store.dispatch('load_customer', true).then(() => {
          resolve()
        })
      })
    },
    resetForm() {
      this.text = ''
      this.open_arealist = false
      this.errors = {}
      this.selectedArea = ''
      this.deliveryArea.nearest_landmark = ''
      this.deliveryArea.street = ''
      this.deliveryArea.building = ''
      this.deliveryArea.flat_number = ''
      this.isEditing = false
    },
  },
}
</script>

<style lang="scss">
.validation-error {
  color: #dc3545;
  font-weight: 600;
}

.coords {
  font-size: 0.6rem;
}

.delivery-area {
  display: block;
  border: $px1 solid $light-border;
  border-top: none;

  li {
    display: block;
    padding: $px10 $px15;
    border-bottom: $px1 solid $light-border;

    &:last-child {
      border-bottom: none;
    }
  }
}
.delivery-timeline {
  .media {
    .media-body {
      .timeline-card {
        text-align: left;
        ul {
          display: block;
          li {
            &:first-child {
              width: auto;
            }
            &:last-child {
              margin-left: auto;
              text-align: left;
            }
          }
        }
      }
    }
  }
}

.body-rtl {
  .edit-profile {
    .modal-body {
      .btns {
        text-align: left;

        .btn {
          + .btn {
            margin-right: $px8;
            margin-left: unset;
          }
        }
      }

      label {
        text-align: right;
        float: right;
      }

      span {
        float: right;
      }
    }
  }

  .vs--searchable {
    .vs__dropdown-toggle {
      width: 100%;
    }
  }
}
</style>
